import sagas from './sagas';
import buildStore from 'dynamic-form-components/lib/store';
import globalDonationRootReducer from './state/rootReducer';
// @ts-ignore
const store: any = buildStore(globalDonationRootReducer, sagas);
export default store;